import {registerPaymentMethod} from '@woocommerce/blocks-registry';
import {getSetting} from '@woocommerce/settings';
import {canMakePayment, LocalPaymentIntentContent} from './local-payment-method';
import {PaymentMethodLabel, PaymentMethod} from '@wc-stripe/blocks-components';
import SavedCardComponent from '../saved-card-component';

const data = getSetting('stripe_ach_data');

if (data) {
    registerPaymentMethod({
        name: data.name,
        label: <PaymentMethodLabel
            title={data.title}
            paymentMethod={data.name}
            icons={data.icon}/>,
        ariaLabel: 'ACH Payment',
        canMakePayment: canMakePayment(data.gatewayId),
        content: <PaymentMethod
            content={LocalPaymentIntentContent}
            data={data}
            mandate={!data.mandate}
        />,
        edit: <PaymentMethod
            content={LocalPaymentIntentContent}
            data={data}
            mandate={!data.mandate}/>,
        savedTokenComponent: <SavedCardComponent data={data}/>,
        placeOrderButtonLabel: data.placeOrderButtonLabel,
        supports: {
            showSavedCards: data.showSavedCards,
            showSaveOption: data.showSaveOption,
            features: data.features
        }
    });
}
